<template>
  <div>
    <div id="lateral-menu-opener" v-on:click="lateralMenu_open"></div>
    <div id="lateral-menu-closure" v-on:click="lateralMenu_close">&#10005;</div>
    <div id="lateral-menu">
      <ul><!--
        --><router-link to="/admin/reservations" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Réservations</a></li>
        </router-link><!--
        --><router-link to="/admin/bons-cadeaux" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Bons cadeaux</a></li>
        </router-link><!--
        --><router-link to="/admin/codes-promos" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Codes promos</a></li>
        </router-link><!--
        --><router-link to="/admin/sessions/nestor" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li v-bind:class="[ isExactActive && 'active' ]"><a v-bind:href="href">Sessions</a></li>
        </router-link><!--
        --><router-link to="/" v-slot="{ href, route, navigate, isActive, isExactActive }">
          <li v-bind:class="[ isExactActive && 'active' ]" class="headerMenu_reserver"><a v-bind:href="href">Lock Quest</a></li>
        </router-link><!--
      --></ul>
    </div>
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es';

export default {
  name: "LateralMenu_Admin",
  methods: {
    lateralMenu_open: function() {
      anime({
        targets: [ '#lateral-menu' ],
        left: '0%',
        duration: 100,
        easing: 'linear'
      });

      anime({
        targets: [ '#lateral-menu-opener' ],
        opacity: [1, 0],
        duration: 100,
        easing: 'linear'
      });

      anime({
        targets: [ '#lateral-menu-closure' ],
        right: '3.5%',
        duration: 100,
        easing: 'linear'
      });
    },
    lateralMenu_close: function() {
      anime({
        targets: [ '#lateral-menu' ],
        left: '-90%',
        duration: 100,
        easing: 'linear'
      });

      anime({
        targets: [ '#lateral-menu-opener' ],
        opacity: [0, 1],
        duration: 100,
        easing: 'linear'
      });

      anime({
        targets: [ '#lateral-menu-closure' ],
        right: '100%',
        duration: 100,
        easing: 'linear'
      });
    }
  }
}
</script>
